import React from 'react';
import './layoutpublic.css';
import { Outlet } from 'react-router-dom';

const PublicLayout = ({ children }) => {
    return (
        <div className="layout-container">
            <main>
                <Outlet/>
            </main>
        </div>
    );
};

export default PublicLayout;
